import api from '~/utils/api';
import { makeDraftClaimLineItemWithReasonAction } from '~/utils/routing';

export const { action, useActionResult: useFollowUpActionResult } =
  makeDraftClaimLineItemWithReasonAction(({ context }, appStore) => {
    const { draftClaimLineItem } = context;

    return api
      .confirmAfterReasonSelection({
        params: { storefrontId: context.settings.storefrontId },
        query: {
          originalStoreOrderLineItemId: draftClaimLineItem.lineItem.id,
        },
      })
      .then(() => {
        // item not eligible for return
        appStore.dispatch(
          appStore.actions.invalidateLineItem(draftClaimLineItem.id),
        );

        return {
          ok: true,
        };
      })
      .catch(() => ({ ok: false }));
  });
